import { DEFAULT_INTERNAL_TOOLS_SETTINGS } from '@repo/internal-tools-app-lib/src/constants/internalToolsAppSettings.ts'
import type { SettingsConfig } from '@repo/internal-tools-app-lib/src/lib/settingStore/settingsConfigSchema.ts'
import { createUseSettingItemValueHook } from '@repo/internal-tools-app-lib/src/lib/settingStore/useSettingItemValue.ts'

export const QUEUE_APP_SETTINGS = {
  settingsId: 'ccc-queue-app',
  sections: {
    appearance: DEFAULT_INTERNAL_TOOLS_SETTINGS.sections.appearance,
    featureFlags: DEFAULT_INTERNAL_TOOLS_SETTINGS.sections.featureFlags,
  },
} as const satisfies SettingsConfig

export const useQueueAppSettingItemValue =
  createUseSettingItemValueHook(QUEUE_APP_SETTINGS)
